export default 'https://uni-mainnet.likwid.fi'